import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Building2, KeyRound, Landmark, Settings as SettingsIcon,
  User, Users
} from "lucide-react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ProfileTab from "./tabs/ProfileTab";
import PrintersTab from "./tabs/PrintersTab";
import UsersTab from "./tabs/UsersTab";
import ProfileEmpresaTab from "./tabs/ProfileEmpresaTab";
import CoordenadasBancariasTab from "./tabs/CoordenadasBancariasTab";
import LicenseTab from "./tabs/LicenseTab";
import { getText } from "../i18n";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("perfil");
  const language = useSelector((state) => state.language?.currentLanguage || "pt-AO");
  const t = getText(language, "settings");

  const tabs = [
    { id: "perfil", label: t.tabProfile, icon: <User size={16} /> },
    { id: "utilizadores", label: t.tabUsers, icon: <Users size={16} /> },
    { id: "empresa", label: t.tabCompany, icon: <Building2 size={16} /> },
    { id: "contas-bancarias", label: t.tabBank, icon: <Landmark size={16} /> },
    // { id: "licenca", label: "Licenca", icon: <KeyRound size={16} /> },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "perfil": return <ProfileTab />;
      case "utilizadores": return <UsersTab />;
      case "empresa": return <ProfileEmpresaTab />;
      case "contas-bancarias": return <CoordenadasBancariasTab />;
      case "licenca": return <LicenseTab />;
      default:
        return (
          <div className="settings-empty">
            <SettingsIcon size={46} />
            <h5>{t.devTitle}</h5>
          </div>
        );
    }
  };

  return (
    <div id="layout-wrapper">
      <Navbar />
      <Sidebar />

      <main className="app-wrapper">
        <div className="container-fluid">
          <section className="settings-shell">
            <header className="settings-header">
              <div>
                <span>{t.header}</span>
                <h1>{t.tabProfile}</h1>
              </div>
              <SettingsIcon size={24} />
            </header>

            <div className="settings-body">
              <nav className="settings-tabs" aria-label={t.header}>
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={activeTab === tab.id ? "active" : ""}
                    type="button"
                  >
                    {tab.icon}
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>

              <div className="settings-content">
                {renderContent()}
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <style>{`
        .settings-shell {
          overflow: hidden;
          border: 1px solid var(--fz-border);
          border-radius: 22px;
          background: var(--fz-surface);
          box-shadow: var(--fz-shadow);
        }

        .settings-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 28px;
          border-bottom: 1px solid var(--fz-border);
          background: var(--fz-surface-2);
        }

        .settings-header span {
          color: var(--fz-muted);
          font-size: 11px;
          font-weight: 900;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .settings-header h1 {
          margin: 5px 0 0;
          font-size: 28px;
          font-weight: 900;
          color: var(--fz-text);
        }

        .settings-body {
          display: grid;
          grid-template-columns: 260px 1fr;
          min-height: 620px;
        }

        .settings-tabs {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 18px;
          border-right: 1px solid var(--fz-border);
          background: color-mix(in srgb, var(--fz-surface-2) 70%, transparent);
        }

        .settings-tabs button {
          display: flex;
          align-items: center;
          gap: 10px;
          min-height: 44px;
          border: 1px solid transparent;
          border-radius: 14px;
          color: var(--fz-muted);
          background: transparent;
          font-size: 13px;
          font-weight: 800;
          text-align: left;
        }

        .settings-tabs button.active,
        .settings-tabs button:hover {
          border-color: var(--fz-border);
          color: var(--fz-text);
          background: var(--fz-surface);
        }

        .settings-tabs button.active svg {
          color: var(--fz-primary);
        }

        .settings-content {
          min-width: 0;
          padding: 24px;
        }

        .settings-empty {
          display: grid;
          place-items: center;
          min-height: 340px;
          color: var(--fz-muted);
          text-align: center;
        }

        @media (max-width: 991.98px) {
          .settings-body {
            grid-template-columns: 1fr;
          }

          .settings-tabs {
            flex-direction: row;
            overflow-x: auto;
            border-right: 0;
            border-bottom: 1px solid var(--fz-border);
          }

          .settings-tabs button {
            white-space: nowrap;
          }
        }
      `}</style>
    </div>
  );
};

export default Settings;
